import React, { useEffect, useState } from 'react';
import { CinematicHeader } from './components/CinematicHeader';
import { ServiceFooter } from './components/ServiceFooter';
import { GlobalFooter } from './components/GlobalFooter';
import { Home } from './pages/Home';
import { Experience } from './pages/Experience';
import { Menu } from './pages/Menu';
import { Events } from './pages/Events';
import { Gallery } from './pages/Gallery';
import { DressCode } from './pages/DressCode';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
export interface CartItem {
  id: string;
  name: string;
  price: number;
  image: string;
  quantity: number;
}
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [cart, setCart] = useState<CartItem[]>([]);
  const addToCart = (item: Omit<CartItem, 'quantity'>) => {
    setCart(prev => {
      const existing = prev.find(i => i.id === item.id);
      if (existing) {
        return prev.map(i => i.id === item.id ? {
          ...i,
          quantity: i.quantity + 1
        } : i);
      }
      return [...prev, {
        ...item,
        quantity: 1
      }];
    });
  };
  const updateQuantity = (id: string, quantity: number) => {
    if (quantity <= 0) {
      setCart(prev => prev.filter(i => i.id !== id));
    } else {
      setCart(prev => prev.map(i => i.id === id ? {
        ...i,
        quantity
      } : i));
    }
  };
  const removeFromCart = (id: string) => {
    setCart(prev => prev.filter(i => i.id !== id));
  };
  const clearCart = () => setCart([]);
  const cartItemCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);
    const elements = document.querySelectorAll('.fade-section');
    elements.forEach(el => observer.observe(el));
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, [currentPage]);
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home onNavigate={setCurrentPage} data-id="element-0" />;
      case 'experience':
        return <Experience data-id="element-1" />;
      case 'menu':
        return <Menu onAddToCart={addToCart} data-id="element-2" />;
      case 'events':
        return <Events onNavigate={setCurrentPage} data-id="element-3" />;
      case 'gallery':
        return <Gallery data-id="element-4" />;
      case 'dresscode':
        return <DressCode data-id="element-5" />;
      case 'cart':
        return <Cart items={cart} onUpdateQuantity={updateQuantity} onRemoveItem={removeFromCart} onNavigate={setCurrentPage} data-id="element-6" />;
      case 'checkout':
        return <Checkout items={cart} onNavigate={setCurrentPage} onClearCart={clearCart} data-id="element-7" />;
      default:
        return <Home onNavigate={setCurrentPage} data-id="element-8" />;
    }
  };
  return <div className="min-h-screen bg-matte text-white font-sans selection:bg-gold/30 selection:text-white" data-id="element-9">
      <CinematicHeader onNavigate={setCurrentPage} currentPage={currentPage} cartItemCount={cartItemCount} data-id="element-10" />
      {renderPage()}
      <ServiceFooter data-id="element-11" />
      <GlobalFooter onNavigate={setCurrentPage} data-id="element-12" />
    </div>;
}